/* eslint-disable import/prefer-default-export */
const isDefined = v => v !== undefined && v !== null;

const cleanValue = (curr, orig) => {
	if (curr === null) {
		return undefined;
	}
	if (curr === undefined) {
		return isDefined(orig) ? orig : undefined;
	}
	return curr;
};

export const createXYMinMaxObject = (
	{ xMin, xMax, yMin, yMax, y2Min, y2Max },
	originalXYMinMaxObject = {}
) => {
	const result = {
		xMin: cleanValue(xMin, originalXYMinMaxObject.xMin),
		xMax: cleanValue(xMax, originalXYMinMaxObject.xMax),
		yMin: cleanValue(yMin, originalXYMinMaxObject.yMin),
		yMax: cleanValue(yMax, originalXYMinMaxObject.yMax)
	};

	const hasSecondYAxis = isDefined(y2Min) || isDefined(y2Max);
	if (hasSecondYAxis) {
		result.y2Min = cleanValue(y2Min, originalXYMinMaxObject.y2Min);
		result.y2Max = cleanValue(y2Max, originalXYMinMaxObject.y2Max);
	}

	return result;
};
